module.exports = __webpack_public_path__ + "static/media/Wsparcie_sprzedazy_1_C.e3a7cc41.png";